export var RSocketState;
(function (RSocketState) {
    RSocketState["Disconnected"] = "Disconnected";
    RSocketState["Connected"] = "Connected";
    RSocketState["Error"] = "Error";
    RSocketState["Reconnecting"] = "Reconnecting";
})(RSocketState || (RSocketState = {}));
export var BackpressureStrategy;
(function (BackpressureStrategy) {
    BackpressureStrategy[BackpressureStrategy["BufferDelay"] = 0] = "BufferDelay";
    BackpressureStrategy[BackpressureStrategy["Drop"] = 1] = "Drop";
})(BackpressureStrategy || (BackpressureStrategy = {}));
